import { dashboard } from 'types';
import { toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  servers: dashboard.BusinessServer[];
}

const initialState: State = {
  servers: [],
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.BUSINESS_SERVER_FETCH_DONE:
      return {
        ...state,
        servers: toJSONArray<dashboard.BusinessServer>(payload),
      };
    default:
      return state;
  }
}
